import model from 'modules/cluster/clusterModel';

const { fields } = model;

export default [
  fields.id,
  fields.company,
  fields.sequence,
  fields.name,
  fields.clusterEbox,
  fields.enable,
  fields.createdAt,
  fields.updatedAt
];
